import React, { useState } from "react";
import styles from "./PaymentOptions.module.css";
import { CreditCard, Bitcoin, QrCode } from "lucide-react";
import { toast } from "react-toastify";

const PaymentOptions = ({
  onPaymentMethodChange,
  selectedMethod = "razorpay",
}) => {
  const [method, setMethod] = useState(selectedMethod);
  const [upiMethod, setUpiMethod] = useState("qr");
  const handleMethodChange = (e) => {
    const newMethod = e.target.value;
    setMethod(newMethod);
    if (onPaymentMethodChange) {
      if (newMethod === "matrixsols") {
        onPaymentMethodChange(newMethod, { method: upiMethod });
      } else {
        onPaymentMethodChange(newMethod);
      }
    }
  };

  const handleUpiMethodChange = (subMethod) => {
    setUpiMethod(subMethod);
    if (onPaymentMethodChange) {
      onPaymentMethodChange("matrixsols", { method: subMethod });
    }
  };

  return (
    <div className={styles.paymentOptions}>
      <h3 className={styles.sectionTitle}>Select Payment Method</h3>

      <div className={styles.paymentMethods}>
        {/* Razorpay Option */}
        <label
          className={`${styles.paymentMethod} ${method === "razorpay" ? styles.active : ""}`}
        >
          <input
            type="radio"
            name="paymentMethod"
            value="razorpay"
            checked={method === "razorpay"}
            onChange={handleMethodChange}
            className={styles.radioInput}
          />
          <div className={styles.methodContent}>
            <div className={styles.methodIcon}>
              <CreditCard size={24} className={styles.icon} />
            </div>
            <div className={styles.methodDetails}>
              <span className={styles.methodName}>Razorpay</span>
              <span className={styles.methodDescription}>
                180+ currencies / multiple methods
              </span>
            </div>
          </div>
        </label>

        {/* MatrixSols / UPI Option */}
        <div className={styles.upiOptionContainer}>
          <label
            className={`${styles.paymentMethod} ${method === "matrixsols" ? styles.active : ""}`}
          >
            <input
              type="radio"
              name="paymentMethod"
              value="matrixsols"
              checked={method === "matrixsols"}
              onChange={handleMethodChange}
              className={styles.radioInput}
            />
            <div className={styles.methodContent}>
              <div className={styles.methodIcon}>
                <QrCode size={24} className={styles.icon} />
              </div>
              <div className={styles.methodDetails}>
                <span className={styles.methodName}>Scan & Pay / UPI</span>
                <span className={styles.methodDescription}>
                  Pay via GPay, PhonePe, Paytm, etc.
                </span>
              </div>
            </div>
          </label>
        </div>

        {/* NowPayments Option */}
        <label
          className={`${styles.paymentMethod} ${method === "nowpayments" ? styles.active : ""}`}
        >
          <input
            type="radio"
            name="paymentMethod"
            value="nowpayments"
            checked={method === "nowpayments"}
            onChange={handleMethodChange}
            className={styles.radioInput}
          />
          <div className={styles.methodContent}>
            <div className={styles.methodIcon}>
              <Bitcoin size={24} className={styles.icon} />
            </div>
            <div className={styles.methodDetails}>
              <span className={styles.methodName}>NOWPayments</span>
              <span className={styles.methodDescription}>
                Crypto, charges and t&c apply.
              </span>
            </div>
          </div>
        </label>
      </div>
    </div>
  );
};

export default PaymentOptions;
